import React, { useState } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2, ArrowUpDown, Plus } from 'lucide-react';
import AddEditTrainingVideo from "./AddEditVideo";
import VideoCard from "./VideoCard";
import VideoModal from "./VideoModal";

function TrainingModule({ moduleData, deleteModule, editModule, orderVideoList, changeInVideo, videoDeleted }) {
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [showVideoPlayPopup, setShowVideoPlayPopup] = useState(false);
    const [videoId, setVideoIdState] = useState('');
    const [videoName, setVideoName] = useState('');
    const [videoEditMode, setVideoEditMode] = useState(false);
    const [videoEditData, setVideoEditData] = useState('');

    const setVideoId = (id, title) => {
        setVideoIdState(id);
        setVideoName(title);
    };

    const handleEditVideo = (isEditing, vData) => {
        setVideoEditMode(isEditing);
        setVideoEditData(vData);
        setShowVideoPopup(true);
    };

    const handleOrderModule = () => {
        try {
            if (orderVideoList) orderVideoList(moduleData);
        } catch (error) {}
    };

    if (!moduleData) return null;

    return (
        <>
            <Card className="border-border bg-card">
                <CardHeader className="border-b border-border">
                    <div className="flex flex-wrap items-center justify-between gap-y-2 gap-x-4">
                        <h3 className="text-lg font-semibold text-primary min-w-0 flex-1">
                            {moduleData.moduleName}
                        </h3>
                        <div className="flex items-center gap-2 flex-shrink-0">
                            {moduleData.media.length > 1 && (
                                <Button
                                    variant="outline"
                                    size="sm"
                                    className="text-primary border-border hover:bg-muted"
                                    onClick={handleOrderModule}
                                >
                                    <ArrowUpDown className="h-4 w-4 mr-2" />
                                    Reorder
                                </Button>
                            )}
                            <Button
                                variant="ghost"
                                size="icon"
                                className="text-primary hover:bg-muted hover:text-primary"
                                onClick={() => { if (editModule) editModule(true, moduleData); }}
                            >
                                <Pencil className="h-4 w-4" />
                            </Button>
                            <Button
                                variant="ghost-destructive"
                                size="icon"
                                onClick={() => deleteModule(moduleData.objectUID)}
                            >
                                <Trash2 className="h-4 w-4" />
                            </Button>
                        </div>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    {moduleData.media.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 xl:grid-cols-3 gap-4">
                            {moduleData.media.map((item, index) => (
                                <VideoCard
                                    key={index}
                                    videoData={item}
                                    getVideoId={setVideoId}
                                    showVideoModal={() => setShowVideoPlayPopup(true)}
                                    editVideo={() => handleEditVideo(true, item)}
                                    moduleId={moduleData.objectUID}
                                    videoDeleted={videoDeleted}
                                />
                            ))}
                            <Button
                                variant="outline"
                                className="h-full min-h-[200px] border-[3px] border-dashed border-muted-foreground/40 bg-muted hover:bg-muted hover:border-accent transition-all"
                                onClick={() => setShowVideoPopup(true)}
                            >
                                <div className="flex flex-col items-center gap-2">
                                    <Plus className="h-10 w-10 text-accent" />
                                    <span className="text-primary font-medium text-md">Add More Media</span>
                                </div>
                            </Button>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center py-8">
                            <p className="text-muted-foreground mb-4">No media added yet</p>
                            <Button onClick={() => setShowVideoPopup(true)} variant="secondary">
                                <Plus className="h-4 w-4 mr-2" />
                                Add Media
                            </Button>
                        </div>
                    )}
                </CardContent>
            </Card>

            {showVideoPopup && (
                <AddEditTrainingVideo
                    moduleData={moduleData}
                    hideModal={() => { setShowVideoPopup(false); setVideoEditMode(false); setVideoEditData(''); }}
                    mode={videoEditMode ? "EDIT" : 'ADD'}
                    videoData={videoEditData}
                    changeInVideo={changeInVideo}
                />
            )}

            {showVideoPlayPopup && (
                <VideoModal
                    hideModal={() => setShowVideoPlayPopup(false)}
                    videoId={videoId}
                    videoName={videoName}
                />
            )}
        </>
    );
}

export default TrainingModule;


